import { render } from "./shopping-cart-content.vue?vue&type=template&id=62debb4a&ts=true"
import script from "./shopping-cart-content.vue?vue&type=script&lang=ts"
export * from "./shopping-cart-content.vue?vue&type=script&lang=ts"

import "./shopping-cart-content.vue?vue&type=style&index=0&id=62debb4a&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__